import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-slider', {
    month: {
        1: 'kuu',
        2: 'kuud',
    },
    year: {
        1: 'aasta',
        2: 'aastat',
    },
    value: 'Väärtus',
    minValue: 'Minimaalne väärtus on',
    maxValue: 'Maksimaalne väärtus on',
});
